/**
 * TradingView 관련 타입 및 데이터 정의
 */
import { ALL_SYMBOL_CODES, getSymbolCategory, groupCodeToCategory } from './symbol-categories';
/**
 * 카테고리별 기본 설정
 */
const CATEGORY_DEFAULTS = {
    forex: {
        type: 'forex',
        exchange: 'Forex',
        pricescale: 10000, // 소수점 4자리
    },
    index: {
        type: 'index',
        exchange: 'Index',
        pricescale: 1, // 정수
    },
    commodity: {
        type: 'commodity',
        exchange: 'Commodity',
        pricescale: 100, // 소수점 2자리
    },
    crypto: {
        type: 'crypto',
        exchange: 'Crypto',
        pricescale: 100, // 소수점 2자리
    },
};
/**
 * 심볼 설명 생성 헬퍼
 */
const generateDescription = (ticker, category) => {
    if (category === 'forex') {
        // EURUSD -> EUR / USD
        const base = ticker.slice(0, 3);
        const quote = ticker.slice(3, 6);
        return `${base} / ${quote}`;
    }
    return ticker;
};
/**
 * ticker와 stockGroupCd로 TradingView 심볼 정보 생성
 * datafeed resolveSymbol에서 목록에 없는 심볼(FR40, DE30 등) 메타데이터 기반 생성용
 */
export function buildSymbolInfoFromMetadata(ticker, stockGroupCd) {
    const category = groupCodeToCategory(stockGroupCd) || 'forex';
    const defaults = CATEGORY_DEFAULTS[category];
    const description = category === 'forex' && ticker.length >= 6
        ? `${ticker.slice(0, 3)} / ${ticker.slice(3, 6)}`
        : ticker;
    return {
        ticker,
        name: ticker,
        description,
        type: defaults.type,
        session: '24x7',
        timezone: 'Etc/UTC',
        exchange: defaults.exchange,
        minmov: 1,
        pricescale: defaults.pricescale,
        has_intraday: true,
        visible_plots_set: 'ohlc',
        has_weekly_and_monthly: true,
        supported_resolutions: ['1', '5', '15', '30', '60', '240', '1D', '1W', '1M'],
        volume_precision: 2,
        data_status: 'streaming',
        format: 'price',
    };
}
/**
 * TradingView 심볼 정보 정적 목록
 * ALL_SYMBOL_CODES + getSymbolCategory(SYMBOL_CATEGORIES) 기반으로 생성
 * 목록에 없는 종목들은 datafeed resolveSymbol에서 buildSymbolInfoFromMetadata로 동적 생성
 */
export const TRADINGVIEW_SYMBOL_INFO_LIST = Object.fromEntries(ALL_SYMBOL_CODES.map((ticker) => {
    const category = getSymbolCategory(ticker) || 'forex';
    const defaults = CATEGORY_DEFAULTS[category];
    return [
        ticker,
        {
            ticker,
            name: ticker,
            description: generateDescription(ticker, category),
            type: defaults.type,
            session: '24x7',
            timezone: 'Etc/UTC',
            exchange: defaults.exchange,
            minmov: 1,
            pricescale: defaults.pricescale,
            has_intraday: true,
            visible_plots_set: 'ohlc',
            has_weekly_and_monthly: true,
            supported_resolutions: ['1', '5', '15', '30', '60', '240', '1D', '1W', '1M'],
            volume_precision: 2,
            data_status: 'streaming',
            format: 'price',
        },
    ];
}));
//# sourceMappingURL=tradingview.js.map